export const TAX_RESPONSIBILITY = [
  { value: 'RESPONSIBILITY_SELL_SIDE', label: 'Bên bán chịu thuế, phí' },
  { value: 'RESPONSIBILITY_BUY_SIDE', label: 'Bên mua chịu thuế, phí' },
  { value: 'RESPONSIBILITY_EACH_SIDE', label: 'Thỏa thuận thuế, phí' },
];

export const TRANSACTION_STATUS = [
  { value: 'INIT', label: 'Chờ xác nhận', color: 'bg-yellow-100 text-yellow-600' },
  { value: 'PROCESSING', label: 'Đang giao dịch', color: 'bg-blue-100 text-blue-600' },
  { value: 'LOCKED', label: 'Đã Khóa', color: 'bg-gray-100 text-gray-600' },
  { value: 'COMPLETED', label: 'Đã hoàn thành', color: 'bg-green-100 text-green-600' },
  { value: 'CANCELLED', label: 'Đã hủy', color: 'bg-red-100 text-red-600' },
];

export const TRANSACTION_TYPE = [
  { value: 'BUYER', label: 'Giao dịch mua' },
  { value: 'SELLER', label: 'Giao dịch bán' },
];

export const DOCUMENT_TYPE = [
  { value: 'DEPOSIT_AGREEMENT', label: 'Thỏa thuận đặt cọc', color: 'text-blue-600' },
  { value: 'ASSIGNMENT_CONTRACT', label: 'Hợp đồng chuyển nhượng', color: 'text-green-600' },
];

export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'FAILED', label: 'Thất bại', color: 'bg-red-100 text-red-600' },
  { value: 'DRAFT', label: 'Bản nháp', color: 'bg-yellow-100 text-yellow-600' },
  { value: 'ACTIVE', label: 'Hoàn thành', color: 'bg-green-100 text-green-600' },
  { value: 'WAIT_SIGN', label: 'Chờ ký', color: 'bg-blue-100 text-blue-600' },
  { value: 'SIGNED', label: 'Đã ký', color: 'bg-blue-100 text-blue-600', disable: true },
  { value: 'CANCELLED', label: 'Từ chối', color: 'bg-red-100 text-red-600', disable: true },
];

export enum DOCUMENT_STATUS {
  FAILED = 'FAILED',
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  WAIT_SIGN = 'WAIT_SIGN',
  SIGNED = 'SIGNED',
}

export enum TRANSACTION_REQUEST_TYPE {
  UPDATE_INFO = 'UPDATE_INFO',
  UPDATE_DOCUMENT = 'UPDATE_DOCUMENT',
}

export interface ObjectPosition {
  urx: number;
  ury: number;
  blx: number;
  bly: number;
  pageIndex: number;
  image?: string;
  info?: any;
}
